import React, { useContext } from 'react';
import styled from '@emotion/styled';

import { NumericField, ScoreField } from '../classes/MetadataFields';
import PlaceholderText from '../components/core/PlaceholderText';
import { instanceOf } from '../drivers/utils';
import { StoreContext } from '../StoreContext';
import { useSearchParams } from '../search_params';
import { useCurrentFeature } from '../utils/hooks';
import { percentify, thousandify } from '../utils/NumFmtUtils';
import {
  getSentimentStatus,
  SENTIMENT_STATUS
} from '../utils/sentimentStatus';

export const CoverageIndicator = () => {
  const {
    project,
    metadata,
    filterCount,
    outlierFilterCount,
    filterIsLoading,
    coverageLoading
  } = useContext(StoreContext);
  const { searchParams } = useSearchParams();
  const feature = useCurrentFeature();

  const sentimentIsReady =
    getSentimentStatus(project) === SENTIMENT_STATUS.READY;
  const hasScoreField = (metadata ?? []).some(
    field => instanceOf(ScoreField, field) || instanceOf(NumericField, field)
  );
  const featureReportsCoverage =
    feature === 'volume' ||
    (feature === 'drivers' && hasScoreField) ||
    (feature === 'sentiment' && sentimentIsReady);

  if (searchParams.concepts !== 'active' || !featureReportsCoverage) {
    return null;
  }

  const covered = filterCount - outlierFilterCount;

  return (
    <Root data-test-id="coverage-indicator">
      Coverage:{' '}
      {filterIsLoading || coverageLoading ? (
        <>
          <PlaceholderText style={{ width: '3rem' }} /> (
          <PlaceholderText style={{ width: '2rem' }} />)
        </>
      ) : (
        <>
          {thousandify(covered)} of {thousandify(filterCount)} (
          {percentify(covered, filterCount)})
        </>
      )}
    </Root>
  );
};

const Root = styled.span`
  flex-shrink: 0;
  font-family: ${({ theme }) => theme.font.sans};
  font-size: 14px;
  white-space: nowrap;
  color: ${({ theme }) => theme.color.primary.base};
`;
